import React from "react";

const Checkbox = ({ id, type, name, handleClick, isChecked }: any) => {
    return (
        <>
            <input
                id={id}
                name={name}
                type={type}
                onChange={handleClick}
                checked={isChecked}
            />
        </>
    );
};

export default Checkbox;